/** @jsx jsx **/
import { jsx, Flex } from 'theme-ui'
import { space } from '~/gatsby-plugin-theme-ui'

const FilterReset = ({ handleClickResetFilters }) => {
  return (
    <Flex
      sx={{
        justifyContent: ['center', null, 'flex-end'],
        pb: [space.md],
        height: '45px',
      }}
    >
      <button
        sx={{
          color: 'muted',
          backgroundColor: 'transparent',
          border: 'none',
          fontSize: '18px',
          cursor: 'pointer',
        }}
        onClick={handleClickResetFilters}
      >
        RESET FILTERS
      </button>
    </Flex>
  )
}

export default FilterReset
